/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Message } from '../../../redux/actions';
import { makeStyles } from '@material-ui/core/styles';

import _ from 'lodash'


const useStyles = makeStyles((theme) => ({
  html: {
    '& pre': {
      color: theme.palette.text.primary
    }
  }
}))

const FindingMessages = (props) => {
  const classes = useStyles()

  const { comments, users } = props

  useEffect(() => {
    props.fetchComments();
  }, []) /* eslint-disable-line */

  if (comments.length === 0) {
    return <div className="findingMessages" />;
  }

  return (
    <div className="findingMessages hasComments">
      {
      comments.map((comment, index) => {
        const sender = users[comment.sender];
        return (
          <div key={index} className="comment">
            <div className="commentLabel">
              { sender
                ? (
                  <span className="commentSender">
                    {`${sender.first_name} ${sender.last_name} `}
                  </span>
                )
                : null }
              <span>{ moment.utc(comment.created).tz(moment.tz.guess(true)).format('lll z') }</span>
            </div>
            <div className={classes.html} dangerouslySetInnerHTML={{ __html: comment.body }} />
          </div>
        );
      })
    }
    </div>
  );
}

FindingMessages.propTypes = {
  fetchComments: PropTypes.func.isRequired,
  comments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  users: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state, { findingId }) => {
  let comments = state.message.getIn(['messages', findingId], [])
  return {
    users: state.users.byId,
    comments: _.orderBy(comments, 'created')
  }
};

const mapDispatchToProps = (dispatch, { findingId }) => ({
  fetchComments: () => dispatch(Message.getCommentsForFinding({ findingId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingMessages);
